module.exports = __webpack_public_path__ + "assets/img/ko-1f6fc845.png";